import { httpRequest } from "@services/http";
import type { LaunchNetworkConfig } from "@models/launchNetwork.model";
import { LaunchNetworkConfigSerializer } from "@models/serializers/launchNetworkSerializer";

export class CommandSelectNetworkResource {
  async run(
    launchId: number,
    network: string,
    networkResourceId: number,
    subResourceId?: number,
  ): Promise<LaunchNetworkConfig> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/networks/${network}/account/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify({
        network_resource_id: networkResourceId,
        network_sub_resource_id: subResourceId,
      }),
    });

    const serializer = new LaunchNetworkConfigSerializer();
    return serializer.deserialize(response);
  }
}
